import { useCallback, useState } from "react";
import { SharedLoginService, SharedLoginPreferredLanguage } from "../../../api/sharedLogin.service";
import { signInWithFirebaseCustomToken } from "../../../firebase/firebaseClient";
import { getDashErrorCode } from "../../FlightAlerts/handler/apiError.helper";
import { OtpOutcome } from "../types";

export interface ProvisionAccountParams {
  verifiedPhoneToken: string;
  signupOriginProduct?: string;
  marketingConsent?: boolean;
  preferredLanguage?: SharedLoginPreferredLanguage;
}

export interface UseProvisionAccountResult {
  provisionAccount: (params: ProvisionAccountParams) => Promise<OtpOutcome>;
  isProvisioning: boolean;
}


export const useProvisionAccount = (): UseProvisionAccountResult => {
  const [isProvisioning, setIsProvisioning] = useState(false);

  const provisionAccount = useCallback(async (params: ProvisionAccountParams): Promise<OtpOutcome> => {
    setIsProvisioning(true);
    try {
      const service = new SharedLoginService();
      const response = await service.provisionAccount(
        params.verifiedPhoneToken,
        params.signupOriginProduct,
        params.marketingConsent,
        params.preferredLanguage,
      );

      await signInWithFirebaseCustomToken(response.data.customToken);
      return { success: true };
    } catch (err) {
      const errorCode = getDashErrorCode(err);
      return errorCode !== undefined ? { success: false, errorCode } : { success: false };
    } finally {
      setIsProvisioning(false);
    }
  }, []);

  return { provisionAccount, isProvisioning };
};
